class ccCookieConsent {
    constructor() {
        this.localStorage = localStorage;
        this.dom = {};
        this.dom.win = window;  
        this.dom.lang = document.documentElement.lang; // get the current language from html tag lang attribute (dynamic)
        /*
        * Kirby CookieConsent (obj)
        */
        // this.wcc = window.CookieConsent;
        /* 
        * iframemanager (PLUGIN for CookieConsent)
        * is loadoad manually before custom script in footer
        * note in order for this to function, scripts are loaded in ORDER and with defer (wait for page loaded)
        * the order of dependant scripts is: 1. iFramemanage, 2. Cookieconsent, LAST: this (custom app scripts)
        */
        this.im = iframemanager();
        // The cookie Consent Plugin Object
        
        // Google gtag
        // this.gtag = gtag(); 
    }

    // gtag.js - Consent Moda (via localStorage)
    // set local storage
    // note: we only set "analytics_storage" and leave security_storage "always on"
    // all others are always of
    // we also init the gtag with localStorage already in head (see head/gtag.php) when the page is loaded
    initConsentMode = () => {
        this.setConsentMode({
            ad_storage: false,
            ad_user_data: false,
            ad_personalization : false,
            analytics_storage: false,
            personalization_storage : false,
            functionality_storage: false,
            security_storage: true,
        });
    }
    // set if consent true
    acceptConsentModeAnalytics = () => {
        this.setConsentMode({
            ad_storage: false,
            ad_user_data: false,
            ad_personalization : false,
            analytics_storage: true,
            personalization_storage : false,
            functionality_storage: false,
            security_storage: true,
        });
    }

    setConsentMode = (consent) => {
        const consentMode = {
            'ad_storage': consent.ad_storage ? 'granted' : 'denied',
            'ad_user_data': consent.ad_user_data ? 'granted' : 'denied',
            'ad_personalization': consent.ad_personalization ? 'granted' : 'denied',
            'analytics_storage': consent.analytics_storage ? 'granted' : 'denied',
            'personalization_storage': consent.personalization_storage ? 'granted' :'denied',
            'functionality_storage': consent.functionality_storage ? 'granted' : 'denied',
            'security_storage': consent.security_storage ? 'granted' : 'granted', // always granted- considered to be functional
        };
        gtag('consent', 'update', consentMode);  
        this.localStorage.setItem('consentMode', JSON.stringify(consentMode));
    }    

    /*
    * iFrameManager Plugin (v1.3.0)
    * Dependency - js (hard loaded in footer) and css (bundled in scss) must be present
    */
    // CPiframeManager() {
    runiFrameManager = () => {
      // const im = iframemanager();
      // console.log(this.im); 

      this.im.run({

          onChange: ({ changedServices, eventSource }) => {
            console.log(window.CookieConsent);
            if (eventSource.type === 'click') {
              const servicesToAccept = [
                // ...this.wcc.getUserPreferences().acceptedServices['experience'],
                ...CookieConsent.getUserPreferences().acceptedServices['experience'],
                ...changedServices,
              ];
        
              CookieConsent.acceptService(servicesToAccept, 'experience');
            }
          },

          currLang: this.dom.lang,

          services : {
              youtube : {
                  embedUrl: 'https://www.youtube-nocookie.com/embed/{data-id}',
                  // thumbnailUrl: '{data-poster-url}',
                  thumbnailUrl: 'https://i3.ytimg.com/vi/{data-id}/hqdefault.jpg',
                  iframe : {
                      allow : 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;'
                  },
                  languages : {
                      en : {
                          notice: 'This content is hosted by YouTube. By showing the external content you accept the <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">terms and conditions</a> of youtube.com.',
                          loadBtn: 'Load video',
                          loadAllBtn: "Don't ask again"
                      },
                      de : {
                        notice: 'Dieser Inhalt wird von YouTube gehostet. Durch das Anzeigen der externen Inhalte akzeptieren Sie die <a rel="noreferrer noopener" href="https://www.youtube.com/t/terms" target="_blank">Allgemeine Geschäftsbedingungen</a> von youtube.com.',
                        loadBtn: 'Video laden',
                        loadAllBtn: "Nicht mehr fragen"
                      },
                  },
              },
          }
      });
    }

    /*
    * Set (all) Banner Consents (user initiated)
    */
    setBannerConsents = ({detail}) => {
        
        // YouTube
        if(detail.cookie.services.experience[0] === 'youtube') {
            // equals to  "onAccept:""
            this.im.acceptService('youtube');
        } else {
            // equals to  "onReject:""
            this.im.rejectService('youtube');
        }

        // Analytics (Google gtag)
        if(detail.cookie.services.measurement[0] === 'analytics') {
            this.acceptConsentModeAnalytics(); // set analytics_storage localstorage === granted
        } else {
            this.initConsentMode(); // default - only security_storage is granted per default and assumed to be a functional category
        }
        /*
        console.log('yutube ?', detail.cookie.services.experience[0]); 
        console.log('onConsent GA', localStorage.getItem('consentMode'));
        */ 
    }

    addListeners() {
        // On First Consent
        this.dom.win.addEventListener('cc:onFirstConsent', ({detail}) => {
            this.setBannerConsents({detail}); 
        });

        // On Consent (also on First Consent)
		this.dom.win.addEventListener('cc:onConsent', ({detail}) => {
            this.setBannerConsents({detail}); 
		});
		
		// On Change
		this.dom.win.addEventListener('cc:onChange', ({detail}) => {
            this.setBannerConsents({detail}); 
		});

    }

    init() {
        // check local storage (should be already done by "head/gtag.php")
        // if not already done -> set / init default
        if(this.localStorage.getItem('consentMode') === null) {
            // set defaults
            this.initConsentMode();
        }

        this.runiFrameManager();

        this.addListeners();

    }
}


export default ccCookieConsent;

